import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueueSmartComponent } from './queue-smart/queue-smart.component';
import { QueueComponent } from './queue/queue.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [QueueSmartComponent, QueueComponent],
  imports: [
    CommonModule,
    DragDropModule,
    MatMenuModule,
    MatButtonModule,
    MatGridListModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    QueueSmartComponent,
  ]
})
export class QueueModule { }
